import React from "react";
import { AHSeparator, AHTeamIconCircle, Box } from "arkh";
import {
  Popover,
  PopoverListItem,
  PopoverListItemTitle,
  PopoverSectionHeader,
} from "../../components/mobile/Popover";
import { useIntlTokens } from "../../components/mobile/useIntlTokens";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { UserLoggedInNavigatorParamList } from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { graphql, useFragment } from "react-relay";
import { TeamSettingsPopover_Store$key } from "./__generated__/TeamSettingsPopover_Store.graphql";
import { TeamSettingsPopover_Team$key } from "./__generated__/TeamSettingsPopover_Team.graphql";
import { FormattedMessage } from "react-intl";
import Color from "color";
import { useHasFeatureFlag } from "../../useHasFeatureFlag";
import { FeatureFlags } from "../../config";

export function TeamSettingsPopover(props: {
  onClose(): void;
  navigation: NativeStackNavigationProp<UserLoggedInNavigatorParamList>;
  top: number;
  showTeamAdmin: boolean;
  showStoreAdmin: boolean;
  store: TeamSettingsPopover_Store$key;
  team: TeamSettingsPopover_Team$key;
}) {
  const store = useFragment(
    graphql`
      fragment TeamSettingsPopover_Store on Store {
        id
        name
      }
    `,
    props.store
  );
  const team = useFragment(
    graphql`
      fragment TeamSettingsPopover_Team on Team {
        id
        name
        icon
        color
        isPrivate
      }
    `,
    props.team
  );
  const intl_tokens = useIntlTokens();
  const hasEmployeeRole = useHasFeatureFlag(FeatureFlags.EmployeeRole);

  return (
    <Popover
      onClose={props.onClose}
      top={props.top}
      side="right"
      customWidth={270}
    >
      <Box space="small">
        {props.showStoreAdmin ? (
          <>
            <PopoverSectionHeader title={store.name} />
            <PopoverListItem
              leftIcon="store"
              onPress={() => {
                props.navigation.navigateDeprecated("StoreAdmin", {});
                props.onClose();
              }}
            >
              <PopoverListItemTitle>{intl_tokens.Admin}</PopoverListItemTitle>
            </PopoverListItem>
          </>
        ) : null}
        {props.showStoreAdmin && props.showTeamAdmin ? (
          <AHSeparator spaceVertical="xsmall" />
        ) : null}
        {props.showTeamAdmin ? (
          <>
            <PopoverSectionHeader
              title={team.name}
              tintColor={
                team.color
                  ? Color(team.color).darken(0.2).toString()
                  : undefined
              }
            />
            <PopoverListItem
              left={
                <AHTeamIconCircle
                  type={team.icon}
                  color={team.color}
                  size="smallMedium"
                  isPrivate={team.isPrivate}
                />
              }
              onPress={() => {
                props.navigation.navigateDeprecated("TeamAdmin", {
                  teamId: team.id,
                });
                props.onClose();
              }}
            >
              <PopoverListItemTitle>
                <FormattedMessage
                  description="TeamSettingsPopover: Team Admin"
                  defaultMessage="Team Admin"
                />
              </PopoverListItemTitle>
            </PopoverListItem>
            <PopoverListItem
              leftIcon="team-schedule"
              onPress={() => {
                props.navigation.navigateDeprecated("TeamScheduleAdmin", {
                  teamId: team.id,
                });
                props.onClose();
              }}
            >
              <PopoverListItemTitle>
                <FormattedMessage
                  description="TeamSettingsPopover: Team Schedule Admin"
                  defaultMessage="Edit Team Schedule"
                />
              </PopoverListItemTitle>
            </PopoverListItem>
            {hasEmployeeRole ? (
              <PopoverListItem
                leftIcon="employee-role"
                onPress={() => {
                  props.navigation.navigate("EmployeeRolesAdmin", {
                    teamId: team.id,
                  });
                  props.onClose();
                }}
              >
                <PopoverListItemTitle>
                  {intl_tokens.EditLineup}
                </PopoverListItemTitle>
              </PopoverListItem>
            ) : null}
          </>
        ) : null}
      </Box>
    </Popover>
  );
}
